import Services from "../../services";

class SubKegiatanApi {
  // API SERVER
  get(params) {
    return Services.get("/hrdu/approval_sub_kegiatan/list", { params });
  }

  getHistory(params) {
    return Services.get("/hrdu/approval_sub_kegiatan/history/list", { params });
  }

  getSingle(params) {
    return Services.get("/hrdu/approval_sub_kegiatan/detail", { params });
  }

  approve(data) {
    return Services.post("/hrdu/approval_sub_kegiatan/approve", data);
  }
}

export default new SubKegiatanApi();
